import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: Boolean,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: emits }) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: "checkbox",
    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded",
    checked: __props.modelValue,
    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked)))
  }, null, 40, _hoisted_1))
}
}

})